export default __webpack_public_path__ + "b5972bd55fd37ebdfbd7216379e96e6392c6c641b3a8f3703b24579bfa86d329.png";